import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from "react-moment";
import { cancelSubscription } from "../../../actions/subscribe";

const CancelSubscription = ({
  setshowCancelSubscription,
  subscriber,
  profile: { _id, avatar, firstname, lastname, jobtitle, location },
  cancelSubscription,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            onClick={() =>
              setshowCancelSubscription({ request: false, confirm: false })
            }
            className="fas fa-times fa-3x message-x"
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to cancel your recurring Mentor Subscription to{" "}
            <span className="red bold">
              {firstname} {lastname}
            </span>
            ? Your subscriber benefits will expire on{" "}
            {subscriber && (
              <Moment className="red bold" format="MM/DD/YYYY">
                {subscriber && subscriber.expirationdate}
              </Moment>
            )}
            .
          </div>
          <div className="flex-center">
            <button
              onClick={() =>
                cancelSubscription({ _id, subscriber }) &&
                setshowCancelSubscription({ request: false, confirm: true })
              }
              className="user-request-button background-red"
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              onClick={() =>
                setshowCancelSubscription({ request: false, confirm: false })
              }
              className="user-request-button background-red"
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CancelSubscription.propTypes = {
  auth: PropTypes.object.isRequired,
  cancelSubscription: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  cancelSubscription,
})(CancelSubscription);
